export function getOnlineLabelStatus(minutes, isSearchView = false) {
  if (!minutes) {
    return 'no_label';
  }
  if (minutes < 15) {
    return 'active';
  }
  if (!isSearchView && minutes < 12 * 60) {
    return 'inactive';
  }
  return 'no_label';
}
